module.exports = __webpack_public_path__ + "media/images/official/event_banner_pc-5a9e919dbf29f4ed1476b4675ae65d1a.jpg";